const HOMEINSURANCE_ENDPOINTS = {
  // Profile Details
  HOME_POST_INSURANCE: "frontend/home-insurance/quote",
  DownloadHomeInsurancePDF: "/frontend/generate-home-quote-pdf",
};

export default HOMEINSURANCE_ENDPOINTS;
